import React from 'react';

import DOMPurify from 'isomorphic-dompurify';
import Link from 'next/link';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './UserPPEDocRejectedBanner.module.scss';

type UserPPEDocRejectedBannerProps = {
    reason: string;
};
const UserPPEDocRejectedBanner = ({ reason }: UserPPEDocRejectedBannerProps) => {
    const { t } = useTranslateLpc('common');

    return (
        <div className={css.user_ppe_doc_rejected_banner_container}>
            <Text variant={'mini_label'} color={'white'} customClass={css.user_ppe_doc_rejected_banner_container__desc}>
                {t('user-flow-block.doc-rejected.desc-1')}
            </Text>
            <Text variant={'mini_label'} color={'white'} customClass={css.user_ppe_doc_rejected_banner_container__desc}>
                {reason}
            </Text>
            <div className={css.user_ppe_doc_rejected_banner_container__actions}>
                <Text
                    variant={'mini_label'}
                    color={'white'}
                    customClass={css.user_ppe_doc_rejected_banner_container__desc}
                >
                    {t('user-flow-block.doc-rejected.desc-2')}
                    <Link href={getRoute(ROUTE.LPC.PPE.FORM)}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(t('user-flow-block.doc-rejected.link')),
                            }}
                        />
                    </Link>
                    {t('user-flow-block.doc-rejected.desc-3')}
                </Text>
            </div>
        </div>
    );
};

export default UserPPEDocRejectedBanner;
